export default function WindowChrome() {
  return (
    <div className="flex items-center gap-2 px-6 py-4 bg-[#efebe6]">
      <div className="w-3 h-3 rounded-full bg-[#ff5f57]" />
      <div className="w-3 h-3 rounded-full bg-[#febc2e]" />
      <div className="w-3 h-3 rounded-full bg-[#28c840]" />
    </div>
  )
}
